export const MEMBERSHIP_PAYMENT='MEMBERSHIP_PAYMENT';
export const DONATION_PAYMENT='DONATION_PAYMENT';
